module.exports = __webpack_public_path__ + "img/clock_img@2x.8f5ed44a.png";